import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StorageService} from '../../shared/services/storage.service';
import {CoreConfigService} from '../../../@core/services/config.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: []
})
export class DashboardComponent implements OnInit, AfterViewInit {
    user: any;
    states: any = [];
    data: any;
    id: any;
    public coreConfig: any;
    programs = [];
    courses = [];
    branches = [];
    universities: any = [];
    admins: any = [];
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    counsellors: any = [];

    constructor(public _coreConfigService: CoreConfigService,
                public modalService: NgbModal) {
        this.user = StorageService.getItem('self');
    }


    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.refresh();
    }

    refresh() {
    }
}
